import React, {useEffect, useRef, useState} from "react";
import propTypes from "prop-types";
import Select from "react-select";
import {useGlobal} from "reactn";
import useBreakpoint from "Hooks/useBreakpoint";

export const SearchCategory = ({
                                   categories,
                                   onCategoryChange,
                                   defaultValue,
                                   allCategoriesText = 'All categories'
                               }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [defaultValueInner, setDefaultValueInner] = useState({
        value: null,
        label: allCategoriesText,
    });
    const isMobile = useBreakpoint("mobile");
    const [theme] = useGlobal("theme");
    const selectRef = useRef();
    const onHotelChange = (selected) => {
        onCategoryChange && onCategoryChange(selected.value);
    };
    const categoriesList = [
        {value: null, label: allCategoriesText},
        ...categories?.map((category) => ({value: category, label: category})),
    ];
    const colourStyles = {
        dropdownIndicator: (styles, {isFocused}) => {
            return {
                ...styles,
                color: "#000",
                fontSize: "1.125rem",
                transform: `rotate(${isFocused ? "180deg" : "0deg"})`,
            };
        },
        placeholder: (styles) => {
            return {
                ...styles,
                color: "#000",
                fontSize: "1.125rem",
                fontFamily: theme.font,
            };
        },
        valueContainer: (styles) => {
            return {...styles, padding: 0};
        },
        singleValue: (styles) => {
            return {
                ...styles,
                color: "#000",
                fontSize: "1.125rem",
                fontFamily: theme.font,
                width: "100%",
                borderBottom: `solid 2px ${isFocused ? "#000" : "transparent"}`,
            };
        },
        control: (styles, {isFocused}) => {
            if (isFocused) {
                setIsFocused(true);
            } else {
                setIsFocused(false);
            }
            return {
                ...styles,
                backgroundColor: "#fff",
                height: "auto",
                border: isFocused ? "1px solid #515151" : "none",
                boxShadow: "none",
                borderRadius: 0,
                width: 150,
            };
        },
        menu: (styles) => {
            return {
                ...styles,
                borderRadius: 12,
                overflow: "hidden",
                padding: 0,
                boxShadow: "0px 15px 30px rgba(0, 0, 0, 0.2)",
                width: !isMobile ? 300 : "calc(100vw - 2rem)",
                right: isMobile ? 0 : "unset",
                top: isMobile ? 30 : 40,
            };
        },
        menuList: (styles) => {
            return {...styles, padding: 0};
        },
        option: (styles, {isDisabled, isSelected, isFocused}) => {
            return {
                ...styles,
                border: isFocused ? "1px solid #515151" : "none",
                boxShadow: isFocused ? "0px 0px -10px #515151" : "none",
                backgroundColor: isSelected ? "#E0E0E0" : "#fff",
                color: "#000",
                fontSize: 18,
                fontWeight: 700,
                cursor: isDisabled ? "not-allowed" : "pointer",
                fontFamily: theme.font,
                paddingLeft: 40,
                zIndex: 3,
                ":hover": {
                    backgroundColor: "#E0E0E0",
                    color: "#000",
                },
                ":active": {
                    ...styles[":active"],
                    backgroundColor: "#E0E0E0",
                },
                ":not(:last-child)": {
                    borderBottom: "solid 1px #E0E0E0",
                },
                "::before": {
                    fontFamily: "Font Awesome\\ 6 Pro",
                    content: isSelected ? '"\\f00c"' : "none",
                    position: "absolute",
                    height: 15,
                    width: 15,
                    left: 15,
                    top: 10,
                },
            };
        },
    };

    useEffect(() => {
        if (
            (!defaultValueInner && defaultValue) ||
            (defaultValue && defaultValueInner.value !== defaultValue.value)
        ) {
            setDefaultValueInner(defaultValue);
            selectRef?.current?.select.setValue(defaultValue);
        }
    }, [defaultValue]);
    return (
        <>
            {categoriesList?.length > 1 &&
                <div>
                    <Select
                        tabIndex={"0"}
                        role={"menu"}
                        ref={selectRef}
                        className="category-select"
                        aria-label={"Category"}
                        isSearchable={false}
                        openMenuOnFocus={true}
                        options={categoriesList}
                        onChange={onHotelChange}
                        defaultValue={defaultValueInner}
                        styles={colourStyles}
                        components={{
                            IndicatorSeparator: () => null,
                        }}
                    />
                </div>}
        </>
    );
};

SearchCategory.propTypes = {
    categories: propTypes.array,
};
